import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

// Swiper
import Swiper from 'swiper';
import { Autoplay, EffectFade, Pagination, Navigation, Thumbs, Controller } from 'swiper/modules';

// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { gsapVerticalLoop } from './gsapVerticalLoop';
import Lenis from 'lenis';

// Packery
import Packery from 'packery';

// Components
import headingModule from './heading.js';
import parallaxModule from './parallax.js';

// Modules
headingModule();
parallaxModule();

// Global
window.Alpine = Alpine;


// Swiper
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

window.Swiper = Swiper;
Swiper.use([Autoplay, EffectFade, Pagination, Navigation, Thumbs, Controller]);

// GSAP
gsap.registerPlugin(ScrollTrigger, SplitText);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.SplitText = SplitText;
window.gsapVerticalLoop = gsapVerticalLoop;


// Packery
window.Packery = Packery;

// Inits
Alpine.plugin(collapse);
Alpine.start();

const lenis = new Lenis({
    autoRaf: true,
    duration: 1.2,
    anchors: true,
    prevent: (node) => node.classList?.contains('js-modal')
});

lenis.on('scroll', ScrollTrigger.update);

// add target blank to all links that are external from the current domain
document.querySelectorAll('a[href^="http"]').forEach(link => {
    if (link.href.includes(window.location.origin)) {
        return;
    }
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
});